import axios from 'axios'
import AuthService from "../Service/AuthService"
import AxiosAdapter from "./AxiosAdapter"

const HTTP_UNAUTHORIZED = 401
const LOGIN_API_URL = '/auth/login_check'

export const isAuthError = (error) => {
	if (!axios.isCancel(error)) {
		return (
			( HTTP_UNAUTHORIZED === error.request.status && LOGIN_API_URL !== error.response.config.url ) ||
			( error.response && HTTP_UNAUTHORIZED === error.response.status && LOGIN_API_URL !== error.response.config.url )
		)
	}
	return false
}

const AxiosInterceptor = () => {
	axios.defaults.adapter = AxiosAdapter
	axios.defaults.headers.common = {}
	if (null !== AuthService.getToken()) {
		axios.defaults.headers.common.Authorization = `Bearer ${AuthService.getToken()}`
	}

	axios.interceptors.response.use(
		response => {
			let token = response.headers.authorization

			if (token && token.length > 0 ) {
				AuthService.setToken(token)
			}
			if (null !== AuthService.getToken()) {
				axios.defaults.headers.common.Authorization = `Bearer ${AuthService.getToken()}`
			}
			return Promise.resolve(response)
		},
		error => {
			console.error(error)
			return Promise.reject(error)
		}
	)
}

export default AxiosInterceptor